
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import './lib/i18n'
import './config/firebase' // Initialize Firebase
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import { queryClient } from './lib/react-query'

// Cache busting mechanism
const appVersion = import.meta.env.VITE_BUILD_TIMESTAMP || Date.now().toString()
localStorage.setItem('app-version', appVersion)

// Clear old cache if version changed
const storedVersion = localStorage.getItem('stored-app-version')
if (storedVersion && storedVersion !== appVersion) {
  localStorage.clear()
  sessionStorage.clear()
  // Clear service worker cache if exists
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister()
      }
    })
  }
}
localStorage.setItem('stored-app-version', appVersion)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
